import { settings } from "../../configs/app.js";

export default {
    actions: {
        boot({ commit }, payload) {
            commit("PUSH_MAIN", payload);
        },
    },
    getters: {
        printSize(state) {
            return state.main.printerWidth + " " + state.main.printerHight;
        },
        pos(state) {
            return {
                printerWidth: state.main.printerWidth,
                printerHight: state.main.printerHight,
                overSelling: state.main.overSelling,
                productSkin: state.main.productSkin,
                productName: state.main.productName,
                defaultTaxRate: state.main.defaultTaxRate,
                defaultDiscountRate: state.main.defaultDiscountRate,
                posProductsLimit: state.main.posProductsLimit,
                stopDiscount: state.main.stopDiscount,
                focusIntervel: state.main.focusIntervel,
                isTaxIncluded: state.main.isTaxIncluded,
                barcodeContainsDigits: state.main.barcodeContainsDigits,
                scanningSensitivity: state.main.scanningSensitivity,
                posAutoLoadProducts: state.main.posAutoLoadProducts,
            };
        },
        volume(state) {
            return state.main.volume;
        },
        billing(state) {
            return {
                billLogo: state.main.billLogo,
                billLogoWidth: state.main.billLogoWidth,
                billLogoHeight: state.main.billLogoHeight,
                billAppName: state.main.billAppName,
                billAddress: state.main.billAddress,
                billPhone: state.main.billPhone,
                billType: state.main.billType,
                billBarcode: state.main.billBarcode,
                billDateTime: state.main.billDateTime,
                billRefrence: state.main.billRefrence,
                billItemFontSize: state.main.billItemFontSize,
                billItemQtyFontSize: state.main.billItemQtyFontSize,
                billDateTimeTransFontSize: state.main.billDateTimeTransFontSize,
                billHrFontSize: state.main.billHrFontSize,
                billTermsFontSize: state.main.billTermsFontSize,
                billtextFlow: state.main.billtextFlow,
                billItemUnit: state.main.billItemUnit,
                billBy: state.main.billBy,
                billLogoRound: state.main.billLogoRound,
            };
        },
        currency(state) {
            return {
                symbol: state.main.symbol,
                symbolOnLeft: state.main.symbolOnLeft,
                spaceBetweenAmountAndSymbol:
                    state.main.spaceBetweenAmountAndSymbol,
            };
        },
        demo(state) {
            return state.main.demo;
        },
        general(state) {
            return {
                logoWidth: state.main.logoWidth,
                logoHight: state.main.logoHight,
                site_name: state.main.site_name,
                phone: state.main.phone,
                address_1: state.main.address_1,
                address_2: state.main.address_2,
                address_3: state.main.address_3,
                symbol: state.main.symbol,
                symbolOnLeft: state.main.symbolOnLeft,
                rtl: state.main.rtl,
                theme: state.main.theme,
                spaceBetweenAmountAndSymbol:
                    state.main.spaceBetweenAmountAndSymbol,
                volume: state.main.volume,
                dateFormat: state.main.dateFormat,
                ownnerInfo: state.main.ownnerInfo,
            };
        },
        logo(state) {
            return state.main.logo;
        },
        logoBill(state) {
            return state.main.logoBill;
        },
        mail(state) {
            return {
                from_email: state.main.from_email,
                reply_email: state.main.reply_email,
                mail_driver: state.main.mail_driver,
                mail_host: state.main.mail_host,
                mail_port: state.main.mail_port,
                mail_user: state.main.mail_user,
                mail_password: state.main.mail_password,
                mail_encryption: state.main.mail_encryption,
            };
        },
        overall(state) {
            return state.main;
        },
        rtl(state) {
            return state.main.rtl;
        },
        terms(state) {
            return {
                saleTerms: state.main.saleTerms,
                refundTerms: state.main.refundTerms,
                purhcaseTerms: state.main.purhcaseTerms,
                repairTerms: state.main.repairTerms,
                customTerms: state.main.customTerms,
                billTerms: state.main.billTerms,
                ownnerInfo: state.main.ownnerInfo,
            };
        },
        theme(state) {
            return state.main.theme;
        },
        version(state) {
            return state.main.version;
        },
        printerWidth(state) {
            return state.main.printerWidth;
        },
    },
    mutations: {
        PUSH_MAIN(state, main) {
            state.main = main;
        },
    },
    namespaced: true,
    state: {
        main: settings,
    },
};
